<template>
  <sp-card class="results-map-banner" variant="plain">
    <sp-button
      class="results-map-banner__link"
      variant="text"
      :data-testid="TestId.finder.mapBanner"
      @click="handleSelectMap"
    >
      <span class="results-map-banner__text">
        {{ resultText("map_banner_prompt") }}
        <span class="results-map-banner__cta">{{ resultText("map_banner_cta") }}</span>
      </span>
      <sp-img class="results-map-banner__image" :src="imageUrl" alt=""></sp-img>
    </sp-button>
  </sp-card>
</template>

<script setup>
import { TestId } from "#/test-ids";
import { resultText } from "#ce/components/SpFinder/view-models/result-text";
import { trackControlClick } from "#ce/components/SpFinder/lib/click-analytics";

defineProps({
  /**
   * The banner picture.
   *
   * @type {String}
   */
  imageUrl: {
    type: String,
    default: undefined,
  },
});

const emit = defineEmits(["select-map"]);

function handleSelectMap(event) {
  trackControlClick(event);
  emit("select-map");
}
</script>

<style lang="scss" scoped>
.results-map-banner {
  --banner-radius: var(--sp-comp-finder-results-map-banner-border-radius, 0);
  --banner-text-color: var(--sp-comp-finder-results-map-banner-color, #565656);
  --banner-cta-color: var(--sp-comp-finder-results-map-banner-cta-color, inherit);
  --banner-font-size: var(--sp-comp-finder-results-map-banner-font-size, var(--sp-sys-typescale-h3-font-size));
  --banner-font-weight: var(--sp-comp-finder-results-map-banner-font-weight, var(--sp-sys-typescale-h3-font-weight));
  --banner-letter-spacing: var(--sp-comp-finder-results-map-banner-letter-spacing, normal);
  --banner-text-inset: var(--sp-comp-finder-results-map-banner-text-inset, 45px);

  --sp-comp-card-padding-block: 0;
  --sp-comp-card-padding-inline: 0;
  --sp-comp-card-border-radius: var(--banner-radius);

  display: block;

  &__link {
    --sp-comp-button-padding: 0;
    --sp-comp-button-size: auto;
    --sp-comp-button-width: 100%;
    --sp-comp-button-min-width: 100%;
    --sp-comp-button-justify-content: start;
    --sp-comp-button-content-text-align: start;
    --sp-comp-button-border-radius: var(--banner-radius);
    --sp-comp-button-primary-variant-text-text-color: var(--banner-text-color);
    --sp-comp-button-primary-hover-variant-text-text-color: var(--banner-text-color);
    --sp-comp-button-primary-hover-variant-text-bg-opacity: 0;

    position: relative;
    display: block;
  }

  &__text {
    position: absolute;
    inset-inline-start: var(--banner-text-inset);
    top: 50%;
    transform: translateY(-50%);
    color: var(--banner-text-color);
    font-size: var(--banner-font-size);
    font-weight: var(--banner-font-weight);
    letter-spacing: var(--banner-letter-spacing);
    z-index: 1;
  }

  &__cta {
    color: var(--banner-cta-color);
  }

  &__image {
    --sp-comp-img-display: block;
    --sp-comp-img-width: 100%;
    --sp-comp-img-height: 100%;
    --sp-comp-img-object-fit: cover;

    display: block;
    width: 100%;
    aspect-ratio: var(--sp-comp-finder-results-map-banner-aspect-ratio, auto);
    border-radius: var(--banner-radius);
  }
}
</style>
